import React from 'react';
import { Link } from 'react-router-dom';

import { formattedDate } from '../../utils/date-utils';
import { urlJoin } from '../../utils/url-utils';
import './card.css';
import img from '../../images/img-default.png';
import moment from 'moment';

export default class Card extends React.Component {
    render() {
        const { card, url, onDelete } = this.props;
        const { picture, title, description, id } = card;
        return (
            <div className='card'>
                <div className='card-img'>
                    <img src={picture ? picture : img} alt={ title ? title : 'imagem background' }/>
                </div>
                <div className='card-data'>
                    <div>
                        <span className='card-title'>{title ? title : 'Titulo'}</span>
                        <p className='card-descr'>{description ? description : 'descrição'}</p>
                    </div>
                    <Link to={urlJoin(url, id)}>
                        <button className='card-access'>Acessar</button>
                    </Link>
                    {this.renderExpirationInfo()}
                    <div className='edition-toolbar' title='Deletar item'>
                        <a onClick={onDelete}>
                            <i className='fa fa-trash'/>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    renderExpirationInfo = () => {
        const { startDate, endDate, expired } = this.props.card;
        const isStarted = moment(startDate).startOf('d') <= moment().startOf('d');
        const expires = endDate && (isStarted || !startDate);
        if (!expired) {
            return (
                <div className='expiration-info'>
                    {(!isStarted && startDate) && <p>Inicia em {formattedDate(startDate)}</p>}
                    {expires && <p>Expira em {formattedDate(endDate)}</p>}
                </div>
            );
        } else {
            return (
                <div className='expiration-info'>
                    <p>Esse item expirou</p>
                </div>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/card/card.js